// extracted by mini-css-extract-plugin
module.exports = {"zoomHover":"ThumbnailImage_zoomHover__PoG0B","imageThumbnail":"ThumbnailImage_imageThumbnail__3IaAL"};